import { FC, ReactNode } from 'react'
import { Dropdown } from 'react-bootstrap'

type IDropdownItem = {
  onClick: () => void
  children: ReactNode
  active?: boolean
}

export const DropdownItem: FC<IDropdownItem> = ({ onClick, children, active = false }) => {
  return (
    <Dropdown.Item
      onClick={onClick}
      className='fw-bold fs-7'
      style={{ cursor: 'pointer' }}
      active={active}
    >
      {children}
    </Dropdown.Item>
  )
}
